<script lang="ts">
export default {
  name: "MonitorPage",
};
</script>
<script setup lang="ts">
import { store } from "@/store"
import LeftMonitor from "./components/left-monitor.vue"
import MiddleMonitor from "./components/middle-monitor.vue"
import RightMonitor from "./components/right-monitor.vue"
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'

const $vc: VcViewerProvider = useVueCesium()

onMounted(() => {
  // $vc.creatingPromise.then((readyObj: VcReadyObject) => {
  //    flyToCamera(
  //     $vc.viewer,
  //     {
  //       position: Cesium.Cartesian3.fromDegrees(119.840, 31.010, 1000),
  //       heading: 6.283185307179586,
  //       pitch: -0.5001412827126326,
  //       roll: 6.283185307179586
  //     },
  //   )
  // })
})
</script>

<template>
  <div class="monitor-page pointer-page" :style="store.informationListStore.informationStore().treatActive ? '': 'background-color: none;pointer-events: none;'">
    <left-monitor />
    <middle-monitor />
    <right-monitor />
  </div>
</template>

<style scoped lang="scss">
.monitor-page{
  position: relative;
  // z-index: 1;
  width: 100vw;
  height: 100vh;
}
</style>
